const files = {
  description: 'archivo con el entrenamiento',
  trainmentWeb: 'Playlist con el entrenameinto para web',
  trainmentApp: 'Playlist con el entrenameinto para la app',
};

export default files;
